<template>
<div
  class="d-flex flex-column"
  :class="[
    classProp
  ]"
  v-on-clickaway="hideDropdown"
  @click="toggleOpen"
>
  <label 
    v-if="showLabel"
    class="text-secondary clickable mb-1" 
    :class="{ 
    'cursor-default': disabled, 
      'text-danger font-weight-bold': localShowUnselected && value === null || showUnselected && value === null,
      'invisible': false
    }">
    {{ label }}
  </label>
  <div 
    class="d-flex flex-column position-relative" 
    role="list" tabindex=0 
    @keyup.space="toggleOpen">
    <div 
      class="rounded-top px-2 py-2 py-md-1 justify-content-between align-items-center d-flex flex-row clickable"
      :class="{
        'rounded-bottom' : !open && !isOptional,
        'bg-light' : open && isOptional,
        'bg-saka-green text-white': !disabled && !isOptional, 
        'border border-saka-green text-secondary rounded': !disabled && isOptional, 
        'text-secondary cursor-default bg-light' : disabled, 
        'bg-transparent border border-danger text-secondary':  localShowUnselected && value === null || showUnselected && value === null,
        'shadow': open
      }">
      <div style="min-height: 1.55rem;" role="button"
        :class="{
          'font-italic opacity-50': !localValue
        }">
        {{ localValue ? selectedItemDisplay : label }}
      </div>
      <svg v-if="open" width="16" height="16" class="caret-up" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg" version="1.1">
        <path d="M1408 1216q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"/>
      </svg>
      <svg v-else width="16" height="16" class="caret-down" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg" version="1.1">
        <path d="M1408 704q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"/>
      </svg>
    </div>
    <div 
      :aria-expanded="open"
      role="list"
      class="border border-saka-green bg-white text-dark dropdown-open shadow" 
      :class="{ 
        'mt-2': $runtimeEnvironment.isIE,
        'invisible': !open}" 
      ref="dropdown"
    >
      <div
        class="select-item m-1 pl-2 pr-2 pt-2 pb-1 border-bottom border-grey d-flex justify-content-between clickable" 
        @click="setValue(null)"
        role="listitem" tabindex=0
         v-if="!resetDisabled">
        <div class="select-item-value no-selection-item">{{ $t('select.empty') }}</div>
      </div>
      <div
        v-for="(item, index) in items"
        :key="item"
        class="select-item m-1 pl-2 pr-2 pt-2 pb-1 border-bottom border-grey d-flex justify-content-between clickable"
        @click="setValue(items[index])"
        @keyup.space="setValue(items[index]);toggleOpen();"
        @keyup.enter="setValue(items[index]);toggleOpen();"
        :class="{'disabled text-black-50' : disabledItems.includes(item)}"
        role="listitem"
        tabindex=0>
        <div class="select-item-value">{{ getDisplayItem(index) }}</div>
        <div v-show="localValue === item" class="select-item-selected-indicator text-success"><i class="fas fa-check"></i></div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';
import Bowser from 'bowser'
import {TweenLite, CSSPlugin} from 'gsap'

// eslint-disable-next-line
const plugins = [CSSPlugin]

export default {
  data () {
    return {
      open: false,
      localValue: this.value,
      browser: Bowser.getParser(window.navigator.userAgent),
      localShowUnselected: this.showUnselected,
      blockAutoFillAfterUnselect: this.isOptional
    }
  },
  methods: {
    toggleOpen () {
      if (!this.disabled) {
        this.open = !this.open
        if (this.open) {
          TweenLite.set(this.$refs.dropdown, { height: 'auto', overflowY: 'auto'})
          if (this.$runtimeEnvironment.isMobileOnly) {
            TweenLite.set(this.$refs.dropdown, { maxHeight: '10em'})
          }
          TweenLite.from(this.$refs.dropdown, .2, { height: 0 })
        } else {
          TweenLite.to(this.$refs.dropdown, .2, { height: 0})
        }
        
      }
    },
    hideDropdown () {
      TweenLite.to(this.$refs.dropdown, .2, { height: 0})
      this.open = false
    },
    getDisplayItem (index) {
      if (this.displayItems.length === this.items.length) 
        return this.displayItems[index]
      return this.items[index]
    },
    setValue (value) {
      this.localValue = value
      try {
        if (value === null) {
          this.blockAutoFillAfterUnselect = true
          this.$store.dispatch('removeAutoAppliedFiltersAndLastFilterAndFilter', { filterKey: this.filterKey, propertyName: this.filterPropertyName })
          return
        }
        this.localShowUnselected = false
          this.blockAutoFillAfterUnselect = false
        this.$store.dispatch('setLastFilterAndFilter', { filterKey: this.filterKey, propertyName: this.filterPropertyName, propertyValue: value })
      } catch (err) {
        this.$rollbar.error('Can not set filter to store', err)
      }
      this.$emit("update", value)
    }
  },
  mixins: [clickaway],
  props: {
    classProp: {
      type: String,
      default: 'pl-4 d-flex flex-column mb-3'
    },
    label: String,
    items: {
      type: Array,
      default: () => []
    },
    displayItems: {
      type: Array,
      default: () => []
    },
    value: String,
    disabled: Boolean,
    disabledItems: {
      type: Array,
      default: () => []
    },
    filterKey: {
      type: String,
      required: true
    },
    filterPropertyName: {
      type: String,
      reuqired: true
    },
    showUnselected: {
      type: Boolean,
      default: false
    },
    isOptional: {
      type: Boolean,
      default: false
    },
    resetDisabled: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    selectedItemDisplay () {
      if (this.localValue !== "" && this.displayItems && this.displayItems.length === this.items.length) 
        return this.displayItems[this.items.findIndex(i => i === this.localValue)]
      return this.localValue
    }
  },
  watch: {
    value (newValue) {
      this.localValue = newValue
      if (newValue) this.localShowUnselected = false
    },

    // autoFill
    disabledItems (newValue) {
      // if there is only one value left
      if (newValue.length + 1 === this.items.length) {
        if (!this.blockAutoFillAfterUnselect)
          this.$store.dispatch('trySetAutoFillValues', { scope: 'getters', filterKey: this.filterKey, propertyName: this.filterPropertyName })
      }
    },
    showUnselected (newValue) {
      this.localShowUnselected = newValue
    }
  }
}
</script>

<style lang="scss">
.opacity-50 {
  opacity: .5;
}

.select-item.disabled {
  font-style: italic;
  pointer-events: none;
  cursor: default;
}
.caret-down, .caret-up {
  fill: currentColor
}

.dropdown-open {
  z-index: 10;
  position: absolute;
  margin-top: 1.75rem;
  width: 100%;
  max-height: 16em;
  overflow-y: auto;
}

.border-grey {
  border-color: $dark-grey;
}
.clickable {
  cursor: pointer;
}
.select-item:hover {
  background-color: $light-grey;
}
.select-item-selected-indicator {
  font-weight: bold;
}
.cursor-default {
  cursor: default;
}
</style>
